import { render, staticRenderFns } from "./buyerToSellOnChat.vue?vue&type=template&id=8e69d030&scoped=true"
import script from "./buyerToSellOnChat.vue?vue&type=script&lang=js"
export * from "./buyerToSellOnChat.vue?vue&type=script&lang=js"
import style0 from "./buyerToSellOnChat.vue?vue&type=style&index=0&id=8e69d030&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e69d030",
  null
  
)

export default component.exports